module.exports = "/images/intercard.png?961fdf8d23514678c2d7851b5d92022f";